import React from 'react';
import {
  Box,
  Drawer,
  IconButton,
  Typography,
  Divider,
  Button,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import CategoryFilter from '../../components/CategoryFilter';
import { ICategory } from '../../types/damTypes';

export default function MobileNavDrawer(props: {
  open: boolean;
  onClose: () => void;
  categories: ICategory[];
  selectedCategoryIds: string[];
  onCategorySelect: (ids: string[]) => void;
}) {
  const { open, onClose, categories, selectedCategoryIds, onCategorySelect } = props;

  return (
    <Drawer anchor="left" open={open} onClose={onClose}>
      <Box sx={{ width: 320, maxWidth: '85vw', height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.5 }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Kategorier
          </Typography>
          <IconButton onClick={onClose} aria-label="Stäng">
            <CloseIcon />
          </IconButton>
        </Box>

        <Divider />

        <Box sx={{ p: 2 }}>
          <Button
            fullWidth
            variant={selectedCategoryIds.length === 0 ? 'contained' : 'outlined'}
            onClick={() => onCategorySelect([])}
          >
            Alla
          </Button>
        </Box>

        <Box sx={{ flex: 1, overflowY: 'auto', px: 1 }}>
          <CategoryFilter
            categories={categories}
            selectedCategoryIds={selectedCategoryIds}
            // CategoryFilter uses onCategorySelect internally; keep toggle as a no-op for compatibility.
            onCategoryToggle={() => {}}
            onCategorySelect={onCategorySelect}
          />

          <Divider sx={{ my: 2, mx: 1 }} />

          {/* Prepared, not active: Collections */}
          <List dense>
            <ListItem>
              <LockOutlinedIcon fontSize="small" sx={{ mr: 1, color: 'text.secondary' }} />
              <ListItemText
                primary="Samlingar (kommer senare)"
                primaryTypographyProps={{ color: 'text.secondary' }}
              />
            </ListItem>
          </List>
        </Box>
      </Box>
    </Drawer>
  );
}

